<div class="country__img" [ngClass]="{'uppertext':name || nameRight != undefined}">
    {{nameRight}}
    <img *ngIf="id" [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + id?.toString() +'.svg'" />
     {{name}}
</div>
